import React from "react";
import Pacientes from "../components/Pacientes/";

const PacientesContainer = () => {
  return <Pacientes />;
};

export default PacientesContainer;
